import React from 'react';
import SearchPage from './SearchPage';
import { fetchSearchPage } from '../../utils/lib';
import { ListItemText } from '@mui/material';
import {
  Box,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SearchManufacturer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  
  const renderItem = (item) => (
    <Box
      sx={{
        width: '100%',
        cursor: 'pointer',
      }}
      onClick={() => handleOnClick(item)}
    >
      <ListItemText 
        key={item.id} 
        primary={item.name}
        />
    </Box>
  );

  const handleOnClick = async (item) => {
    navigate('/main/view-manufacturer', { state: { id: item.id } });
  };

  return (
    <SearchPage
      fetchFunction={fetchSearchPage}
      table={'products_manufacturers'}
      renderItem={renderItem}
      placeholder={t('search.searchManufacturer')}
    />
  );
};

export default SearchManufacturer;